import { MessageCircle, X } from "lucide-react";
import { useLeoChatStore } from "@/stores/leo-chat.store";

export function LeoFab() {
  const { isOpen, togglePanel } = useLeoChatStore();

  return (
    <button
      onClick={togglePanel}
      className="fixed bottom-6 right-6 z-[9999] w-14 h-14 rounded-full bg-gradient-to-br from-purple-600 to-purple-400 border-none cursor-pointer flex items-center justify-center shadow-lg shadow-purple-500/40 transition-transform duration-200 hover:scale-105 hover:shadow-xl hover:shadow-purple-500/50"
    >
      {isOpen ? (
        <X className="w-6 h-6 text-white" />
      ) : (
        <MessageCircle className="w-6 h-6 text-white" />
      )}
    </button>
  );
}
